module.exports = __webpack_public_path__ + "img/6.ea127eed.jpg";